module.exports = require("./rwk.d.ts");